<template>
  <a-modal :footer="null" width="1000px" @close="closeModal()" v-model="visible">
    <a-row slot="title" type="flex" justify="space-between">
      <span>常模历史记录</span>
    </a-row>
    <div>
      <a-table :score="{ y: 450 }" :columns="columns" row-key="id" :pagination="false" :loading="tableRelevant.tableLoading" :locale="tableRelevant.locale" :dataSource="tableRelevant.tableDataSource">
        <div slot="name" slot-scope="text">
          <a-tag v-if="text.isDefault" color="#87d068">默认</a-tag>
          {{ text.name }}
        </div>
        <div slot="device" slot-scope="text">
          {{
            equipmentList
              .filter((f) => (f.id | text.deviceType) === text.deviceType)
              .map((m) => m.name)
              .join(' ')
          }}
        </div>
        <div slot="regionName" slot-scope="text">
          <span>{{ text.regionName ? text.regionName : '--' }}</span>
        </div>
        <div slot="dbqy" slot-scope="text">
          {{ text.areaCharacteristicSize && text.areaCharacteristicDescriptions != '[]' ? getDbqy(text.areaCharacteristicDescriptions) : '--' }}
        </div>
        <div slot="action" slot-scope="text">
          <a-button type="link" @click="exportView(text)">导出</a-button>
        </div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import * as xlsx from 'xlsx'
const columns = [
  {
    title: '常模名称',
    scopedSlots: { customRender: 'name' },
  },
  { title: '应用设备', scopedSlots: { customRender: 'device' } },
  {
    title: '应用区域',
    scopedSlots: { customRender: 'regionName' },
  },
  {
    title: '样本量',
    dataIndex: 'sampleSize',
  },
  {
    title: '代表区域',
    scopedSlots: { customRender: 'dbqy' },
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

const contrastColumns = [
  { title: '年龄', dataIndex: 'age', align: 'center' },
  { title: '性别', dataIndex: 'genderName', align: 'center' },
  { title: '样本量', dataIndex: 'existsSampleCount', align: 'center' },
  { title: '平均分', dataIndex: 'existsSampleAvgScore', align: 'center' },
  { title: '标准差', dataIndex: 'existsSampleStd', align: 'center' },
]
export default {
  name: 'ViewRecord',
  data() {
    return {
      tableRelevant: tableRelevant.call(this, this.getList),
      visible: false,
      columns,
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
    }
  },
  computed: {
    getDbqy() {
      return function (areaCharacteristicDescriptions) {
        try {
          const area = JSON.parse(areaCharacteristicDescriptions)
          return area
            .map((item) => {
              if (typeof item === 'string') {
                return item
              } else {
                return item.label
              }
            })
            .join(',')
        } catch (error) {
          return '--'
        }
      }
    },
  },
  methods: {
    showModal(options) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this._options = options
        this.getList(options)
      })
    },
    closeModal(reject) {
      this.visible = false
      this.list = []
      reject ? this._reject() : this.resolve()
    },
    async getList(options) {
      this.tableRelevant.tableLoading = true
      const { data } = await this.$http.NormSet.getNormVersionList({ normId: options.normId }).finally(() => (this.tableRelevant.tableLoading = false))
      this.tableRelevant.tableDataSource = data
    },
    // 导出
    exportView(text) {
      let params = {
        id: text.id,
      }
      this.$http.NormSet.getDetail(params)
        .then((res) => {
          const { status, data, message } = res
          const arr = [contrastColumns.map((m) => m.title)]
          arr[0].unshift('版本名称')
          arr[0].unshift('游戏名称')
          data.norms.forEach((f) => {
            arr.push([
              sessionStorage.getItem('currentName'),
              this.$route.query.version,
              f.age,
              f.gender == 0 ? 'all' : f.gender == 1 ? 'male' : 'female',
              f.sampleCount,
              f.average,
              f.standardDeviation,
            ])
          })
          const aoa = xlsx.utils.aoa_to_sheet(arr)
          const book = xlsx.utils.book_new()
          xlsx.utils.book_append_sheet(book, aoa, '第一页')
          xlsx.writeFile(book, this._options.excelTitle + '.xlsx')
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>
